import React from 'react';

export const customChartTooltip = {
  customItems: (items) => {
    const item = items[0];
    return (
      <div
        className={'flex-col-16'}
        style={{
          alignItems: 'flex-start',
          fontWeight: 500,
          color: 'var(--text)',
          fontSize: '14px',
          paddingInline: 8,
          paddingBlock: 16,
          fontFamily: 'sans-serif',
        }}
      >
        <span style={{ fontWeight: 600, fontSize: 16 }}>{item.title}</span>
        <div className={'flex-16'}>
          <div className={'flex-8'} style={{ fontWeight: 500, fontSize: 16 }}>
            <span
              style={{
                height: 12,
                width: 12,
                borderRadius: '50%',
                backgroundColor: 'var(--primary)',
              }}
            />
            <span>{item.name}:</span>
          </div>
          <span style={{ fontWeight: 500, fontSize: 16 }}>{item.value}</span>
        </div>
      </div>
    );
  },
  customContent: (title, data) => {
    if (data) {
      return data;
    } else {
      return '';
    }
  },
};
